import { useMemo } from 'react';
import { pick } from 'ramda';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { useGetFeedBlacklist } from '@interlayer/js/components/system/App/hooks/useGetGamesConfiguration/helpers';

import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { useAppSelector } from 'js/store/hooks';

export const useAvailableGames = () => {
    const { gamesConfiguration, gamesFeeds } = useAppSelector(pick(['gamesConfiguration', 'gamesFeeds']));
    const [
        dTagSearchIgnoreFeeds = 'DAVE_TEST',
        dTagSearchIgnoreGameTypes = 'RETAIL_GAMES'
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.searchIgnoreFeeds,
        DYNAMIC_TAG_NAMES.searchIgnoreGameTypes
    ]);
    const getGamesBlacklist = useGetFeedBlacklist();
    const blackList = useMemo(() => {
        return getGamesBlacklist(gamesFeeds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gamesFeeds]);

    return useMemo(() => {
        if (!gamesConfiguration) {
            return [];
        }

        const searchIgnoreFeeds = dTagSearchIgnoreFeeds.split(',').map((feed) => feed.trim());
        const searchIgnoreGameTypes = dTagSearchIgnoreGameTypes.split(',').map((type) => type.trim());
        const ignoreCodes = new Set(
            gamesFeeds.reduce((acc, { name, categories }) => {
                if (searchIgnoreFeeds.includes(name) && categories.length) {
                    return acc.concat(categories.reduce((codes, { gameCodes }) => codes.concat(gameCodes), []));
                }

                return acc;
            }, [])
        );

        return Object.keys(gamesConfiguration)
            .reduce((acc, code) => {
                const { active, name, gameType } = gamesConfiguration[code];

                if (active && !ignoreCodes.has(code) && !searchIgnoreGameTypes.includes(gameType) && !blackList.includes(code)) {
                    acc.push({
                        id: code,
                        value: name
                    });
                }

                return acc;
            }, []);
    }, [dTagSearchIgnoreFeeds, dTagSearchIgnoreGameTypes, gamesConfiguration, gamesFeeds, blackList]);
};
